import Vue from 'vue'
import Router from 'vue-router'
import TicketsList from '../components/TicketsList.vue'
import CreateTickets from '../components/CreateTickets.vue'
import CreateTicketsV2 from '../components/CreateTicketsV2.vue'
import Login from '../components/Login.vue'
import SecondStepLogin from '../components/SecondStepLogin.vue'
import AuthService from "../services/AuthService";
import TicketsDashboard from "../components/TicketsDashboard.vue"
import loginInfoService from '../services/LoginInfoService'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/tickets'
    },

    {
      path: '/tickets',
      name: 'Home',
      component: TicketsList
    },

    {
      path: '/create_tickets',
      name: 'Create Tickets',
      component: CreateTicketsV2
    },

    {
      path: '/create_tickets_internal',
      name: 'Create Tickets Internal',
      component: CreateTickets
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    {
      path: '/dashboard',
      name: 'Dashboard',
      component: TicketsDashboard
    },

    {
      path: '/second_step_login',
      name: 'Second Step Login',
      component: SecondStepLogin
    }
  ]
});

var permitedPages = ['/login'];

router.beforeEach((to, from, next) => {
  var token = AuthService.getToken();
  if(to.path === '/tickets' && (to.query.sessionid || to.query.authorization)){
    next();
    return;
  }
  if(permitedPages.includes(to.path)){
    next();
    return;
  }

  var loginInfo = loginInfoService.getLoginInfo()
  if(to.path === '/create_tickets' && loginInfo.internal === true){
    next('/create_tickets_internal');
    return;
  }
  if(to.path === '/create_tickets_internal' && loginInfo.internal === false){
    next('/create_tickets');
    return;
  }
  if(token){
    next();
  }else{
    next('/login');
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js